import React, { useEffect, useRef, useState } from "react";

const SelectWithPills = ({ label, options, value, onChange, disabled, editNotAllowed }) => {
  const [selected, setSelected] = useState([...value]);
  
  useEffect(() => {
    setSelected(value);
  }, [value]);

  const [query, setQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    const filtered = options.filter(
      (opt) =>
        !selected.includes(opt) &&
        opt.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [query, selected, options]);

  const handleSelect = (opt) => {
    const updated = [...selected, opt];
    setSelected(updated);
    onChange(updated);
    setQuery("");
    setIsOpen(false);
  };

  const handleRemove = (opt) => {
    const updated = selected.filter((v) => v !== opt);
    setSelected(updated);
    onChange(updated);
  };

  return (
    <div className="relative w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-800 mb-2">
          {label}
        </label>
      )}

      <div
        className={`border rounded-md p-2 flex flex-wrap items-center gap-2 ${
          disabled ? "opacity-50 bg-gray-100 border-gray-200" : "border-gray-300 bg-white"
        }`}
        onClick={() => inputRef.current?.focus()}
      >
        {selected.map((opt) => (
          <div
            key={opt}
            className="flex items-center bg-blue-50 border border-blue-300 text-blue-600 px-3 py-1 rounded-full text-sm"
          >
            {opt}
            {(!editNotAllowed || disabled) && <button
              onClick={() => handleRemove(opt)}
              className="ml-2 text-blue-500 hover:text-blue-700 font-bold"
            >
              ×
            </button>}
          </div>
        ))}

        {!editNotAllowed && <input
          ref={inputRef}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setIsOpen(true);
          }}
          disabled={disabled}
          placeholder="Type to select..."
          className="flex-1 text-sm focus-within:border-gray-300 focus-visible:outline-none "
        />}
      </div>

      {isOpen && filteredOptions.length > 0 && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-auto text-sm">
          {filteredOptions.map((opt) => (
            <li
              key={opt}
              onClick={() => handleSelect(opt)}
              className="px-3 py-2 cursor-pointer hover:bg-blue-50 text-gray-700"
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};


export default SelectWithPills;
